import {UserGroup} from '@nursio-link/common';
import {useEffect, useState} from 'react';
import {Navigate} from 'react-router-dom';

import {getGroups} from '@/services/authService';

function HomeRedirect() {
  const [targetPath, setTargetPath] = useState<string | null>(null);

  useEffect(() => {
    const determineRedirect = async () => {
      const groups = await getGroups();

      if (groups.includes(UserGroup.AuthorizedRelatives)) {
        setTargetPath('/relative');
      } else {
        setTargetPath('/today');
      }
    };

    determineRedirect();
  }, []);

  if (!targetPath) {
    return null;
  }

  return <Navigate to={targetPath} replace />;
}

export default HomeRedirect;
